<template>
  <div>
    <table class="table table-hover">
      <thead>
      <tr>
        <th v-for="head in getHeaders" class="valid light-gray-bg">{{ headersTranslated[head][0] }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="sample in $store.getters.getSamples">
        <td v-for="head in getHeaders" :class="addInvalidClass(sample[head])">
          <a v-if="contentIncludesIdentifier(sample[head])" class='fa fa-exclamation-circle'
             :content="getTooltipText(sample[head])" v-tippy></a>
          {{ prepareSamplesContent(sample[head]) }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Spinner from "../../common/spinner/Spinner";
export default {
  name: "CustomerMappingsPreviewTable",
  components: {Spinner},
  props: ['allHeaders', 'reducedHeaders', 'headersTranslated'],
  data() {
    return {
      headers: {},
      identifier: '~!~'
    }
  }, methods: {
    fillHeadersWithReducedHeaders() {
      this.headers = this.$props.reducedHeaders;
    },
    addInvalidClass(content) {
      return this.contentIncludesIdentifier(content) ? {invalid: true} : {valid: true}
    },
    contentIncludesIdentifier(content) {
      return content.includes(this.identifier);
    },
    prepareSamplesContent(content) {
      if (!this.contentIncludesIdentifier(content)) {
        return content
      } else {
        content = content.split(this.identifier)
        return content[2]
      }
    },
    getTooltipText(content) {
      content = content.split(this.identifier)
      return content[1]
    }
  },
  computed: {
    getHeaders() {
      if (this.$store.getters.getShowReducedRows) {
        return this.$props.reducedHeaders;
      } else {
        return this.$props.allHeaders;
      }
    },
  },
  mounted() {
    this.fillHeadersWithReducedHeaders();
  }
}
</script>

<style scoped>
.invalid {
  background-color: rgba(255, 0, 0, 0.2);
  padding: 3px 7px 3px 7px;
  white-space: nowrap;
  border-right: solid 1px #efefef;
}

.valid {
  padding: 3px 7px 3px 7px;
  white-space: nowrap;
  border-right: solid 1px #efefef;
}

tr, th, td {
  width: 100%;
}

.fa-exclamation-circle {
  color: red;
}

.light-gray-bg {
  background: #E8E8E8;
}
</style>